// extracted by mini-css-extract-plugin
export default {"container":"h1bNcO","label":"hxOFKx","icon":"iY_6cN","input":"TZRotH","largeInput":"p9PyUM"};